import React from "react";
import "./About.css";
import CTAButton from "../CTA/CTAButton";
import marilia from "../../images/marilia.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import badgeDPO from "../../images/badgeDPO.png";
import badgeISMF from "../../images/badgeISMF.png";
import badgePDPF from "../../images/badgePDPF.png";
import badgePDPP from "../../images/badgePDPP.png";
import LegalGround from "../../images/legalGround.jpg";
import SeloAssociados from "../../images/seloAssociados.png";
import SeloInfinite from "../../images/seloInfinite.png";

const badges = [
  badgeDPO,
  badgeISMF,
  badgePDPF,
  badgePDPP,
  LegalGround,
  SeloAssociados,
  SeloInfinite,
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const About = () => {
  return (
    <section className="sobre" id="sobre">
      <div className="sobre-content">
        <div className="sobre-image">
          <img src={marilia} alt="Juscélia Maruti Milagres" />
        </div>
        <div className="sobre-text">
          <h2>EQUIPE</h2>
          <h3>
            Marília Rodrigues Mazzola é advogada, formada em Direito pela
            Universidade Estadual de Londrina (UEL) e Mestre em Direito Civil
            pela Universidade de São Paulo (USP). Fundadora do escritório
            Advocacia Mazzola.
          </h3>
          <h3>
            Com vasta experiência profissional, já passou por diversas
            multinacionais, e atualmente se dedica ao Direito Bancário, atuando
            na defesa dos consumidores contra abusividades e práticas das
            instituições bancárias e financeiras.
          </h3>
          <h3>
            Além de sua prática jurídica, é professora, palestrante e consultora
            em Lei Geral de Proteção de Dados (LGPD), com certificações
            internacionais.
          </h3>

          <CTAButton />
        </div>
      </div>
      <div className="about-selos">
        <Slider {...settings}>
          {badges.map((badge, index) => (
            <div className="about-selo" key={index}>
              <img src={badge} alt={`Selo ${index + 1}`} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default About;
